import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout';
import * as General from '../General/General';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import moment from 'moment-jalaali';
import DatePicker from 'react-datepicker2';



const DiscountIndex = () => {

    //#region Const
    const toaster = rsuite.useToaster();
    const rowKey = 'id';
    let navigate = useNavigate();
    const [List, setList] = useState([]);
    const [Title, setTitle] = useState('');
    const [Id, setId] = useState(General.GuidEmpty());
    const [DiscountTitle, setDiscountTitle] = useState('');
    const [IsActive, setIsActive] = useState(1);
    const [DiscountType, setDiscountType] = useState(-1);
    const [SearchIsActive, setSearchIsActive] = useState(-1);
    const [BeginDate, setBeginDate] = useState(moment(new Date()).add('days', -30));
    const [EndDate, setEndDate] = useState(moment(new Date()));
    const [ShowModal, setShowModal] = React.useState(false);
    const [sortColumn, setSortColumn] = React.useState();
    const [sortType, setSortType] = React.useState();
    const [loading, setLoading] = React.useState(false)

    //#endregion


    const handleSortColumn = (sortColumn, sortType) => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setSortColumn(sortColumn);
            setSortType(sortType);
        }, 500);
    };
    const BeginDate_Change = e => {
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setBeginDate(moment(m, 'jYYYY/jMM/jDD'));
    }

    const EndDate_Change = e => {
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setEndDate(moment(m, 'jYYYY/jMM/jDD'));
    }


    //#region Methods


    const Search = () => {
        trackPromise(
            fetch(General.ApiRoute() + '/Discount/Search', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'BeginDate': BeginDate != null ? moment(BeginDate.format()).format("jYYYY/jMM/jDD") : "",
                    'EndDate': EndDate != null ? moment(EndDate.format()).format("jYYYY/jMM/jDD") : "",
                    'IsActive': SearchIsActive,
                    'DiscountType': DiscountType,
                    'Title': Title
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    var tmp = []
                    for (var i = 0; i < result.length; i++) {
                        tmp.push({
                            row: i + 1,
                            Id: result[i].id,
                            Title: result[i].title,
                            BeginDate: result[i].beginDate,
                            EndDate: result[i].endDate,
                            DiscountTypeComment: result[i].discountTypeComment,
                            CustomerCount: result[i].customerCount,
                            ProductCount: result[i].productCount,
                            IsActive:result[i].isActive

                        })
                    }
                    setList(tmp)
                })
        )
    }





    const UpdateIsActive = () => {

        var RequestOptions = {
            data: {
                "Id": Id,
                "IsActive": IsActive == 1 ? 0 : 1,
                "Title": DiscountTitle
            },
            url: General.ApiRoute() + "/Discount/UpdateIsActive",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    if (result.data == "OK") {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')
                        Search();
                        setShowModal(false);
                        setIsActive(-1);
                        setDiscountTitle("");
                        setId(General.GuidEmpty())
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )
    }


    const ShowEdit = (id) => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 17);
        myHeaders.append("Operation", 3);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage("AccessDenied")), 'topCenter')

                    }
                    else {
                        navigate("/InsertDiscount")
                        localStorage.setItem("DiscountId", id)
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )


    }

    const ShowNew = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 17);
        myHeaders.append("Operation", 1);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage("AccessDenied")), 'topCenter')
                    }
                    else {
                        navigate("/InsertDiscount")
                        localStorage.setItem("DiscountId", General.GuidEmpty())

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }


    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 17);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        Search();
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }




    useEffect(() => {
        CheckPermission();
        document.title = "بسته تخفیفات";
    }, [])
    //#endregion







    return (

        <Layout title="بسته تخفیفات">


            <div className="h-100 p-1">
                <rsuite.Panel className="bg-white ">
                    <rsuite.Grid fluid>
                        <rsuite.Row>

                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="text-left" >
                                <rsuite.Button appearance="primary" size="xs" className="m-1" onClick={Search}>  جستجو</rsuite.Button>
                                <rsuite.Button appearance="primary" color="green" size="xs" className="m-1" onClick={ShowNew}>  جـــدید</rsuite.Button>

                            </rsuite.Col>
                        </rsuite.Row>
                    </rsuite.Grid>
                    <hr />
                    <rsuite.Row className='p-1'>

                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
                            <label>عنوان</label>
                            <rsuite.Input value={Title} onChange={(e) => setTitle(e)} />
                        </rsuite.Col>

                        <rsuite.Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={12}>
                            <label> از تاریخ </label>
                            <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={BeginDate} onChange={BeginDate_Change} />

                        </rsuite.Col>
                        <rsuite.Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={12}>
                            <label>تا تاریخ </label>
                            <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={EndDate} onChange={EndDate_Change} />
                        </rsuite.Col>
                        <rsuite.Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={12}>
                            <label>نوع</label>
                            <select className="rs-input" onChange={(e) => setDiscountType(e.target.value)} value={DiscountType}>
                                <option value="-1">انتخاب نمایید</option>
                                <option value="1">تخفیف ویژه مشتریان  </option>
                                <option value="2">تخفیف روی محصولات </option>
                            </select>
                        </rsuite.Col>
                        <rsuite.Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={12}>
                            <label> وضعیت فعال بودن   </label>
                            <select className="rs-input" onChange={(e) => setSearchIsActive(e.target.value)} value={SearchIsActive}>
                                <option value="-1">انتخاب نمایید</option>
                                <option value="0">غیر فعال </option>
                                <option value="1">فعال </option>


                            </select>
                        </rsuite.Col>
                    </rsuite.Row>

                    <div className="h-90 p-1">
                        <div className="h-100-y">

                            <rsuite.Panel className="bg-white mt-2">

                                <rsuite.Table
                                    height={520}
                                    data={List.sort((a, b) => {
                                        let x = a[sortColumn];
                                        let y = b[sortColumn];
                                        if (typeof x === 'string') {
                                            x = x.charCodeAt();
                                        }
                                        if (typeof y === 'string') {
                                            y = y.charCodeAt();
                                        }
                                        if (sortType === 'asc') {
                                            return x - y;
                                        } else {
                                            return y - x;
                                        }
                                    })}
                                    sortColumn={sortColumn}
                                    sortType={sortType}
                                    onSortColumn={handleSortColumn}
                                    loading={loading}
                                >

                                    <rsuite.Table.Column width={50} align="center"  >
                                        <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey='row' />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column flexGrow={2} fullText resizable>
                                        <rsuite.Table.HeaderCell>عنوان</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey='Title' />
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column flexGrow={1} fullText resizable>
                                        <rsuite.Table.HeaderCell>تاریخ شروع </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey='BeginDate' />
                                    </rsuite.Table.Column>


                                    <rsuite.Table.Column flexGrow={1} >
                                        <rsuite.Table.HeaderCell>تاریخ پایان</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey='EndDate' />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column flexGrow={1}>
                                        <rsuite.Table.HeaderCell>نوع </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey='DiscountTypeComment' />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column width={100} >
                                        <rsuite.Table.HeaderCell>تعداد مشتریان </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey='CustomerCount' />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column width={100} >
                                        <rsuite.Table.HeaderCell>تعداد محصول </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey='ProductCount' />
                                    </rsuite.Table.Column>



                                    <rsuite.Table.Column fullText width={100} resizable>
                                        <rsuite.Table.HeaderCell>وضعیت   </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>

                                                    {rowData.IsActive == 1 ?

                                                        <BiIcon.BiCheckCircle className="text-success fs-6" />
                                                        :
                                                        <BiIcon.BiXCircle className="text-danger fs-6" />
                                                    }
                                                </>


                                            }}

                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fixed="right" width={60} >
                                        <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>

                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    <rsuite.Whisper placement="autoVerticalStart" trigger="click" speaker={
                                                        <rsuite.Popover full className='PopoverMenu'>
                                                            <rsuite.Dropdown.Menu  >
                                                                <rsuite.Dropdown.Item onClick={() => ShowEdit(rowData.Id)}>ویرایش</rsuite.Dropdown.Item>
                                                                <rsuite.Dropdown.Item onClick={() => (setId(rowData.Id), setDiscountTitle(rowData.Title), setIsActive(rowData.IsActive), setShowModal(true))}>{rowData.IsActive == 1 ? "غیر فعال" : "فعال"}</rsuite.Dropdown.Item>
                                                            </rsuite.Dropdown.Menu>
                                                        </rsuite.Popover>
                                                    }>
                                                        <rsuite.IconButton appearance="subtle" icon={<BiIcon.BiDotsHorizontalRounded />} />
                                                    </rsuite.Whisper>
                                                </>
                                            }}
                                        </rsuite.Table.Cell>

                                    </rsuite.Table.Column>
                                </rsuite.Table>

                            </rsuite.Panel>

                        </div>
                    </div>

                </rsuite.Panel >
            </div >


            <rsuite.Modal open={ShowModal} onClose={() => setShowModal(false)}>
                <rsuite.Modal.Header>
                    <rsuite.Modal.Title><b>
                        {IsActive == 1 ? "غیر فعال کردن" : "فعال کردن"} &nbsp;{DiscountTitle}</b></rsuite.Modal.Title>
                </rsuite.Modal.Header>
                <rsuite.Modal.Body>
                    <div className="mt-3 Font15">

                        آیا از
                        {IsActive == 1 ? "غیر فعال کردن" : "فعال کردن"}

                        &nbsp;{DiscountTitle} اطمینان دارید؟!
                    </div>
                </rsuite.Modal.Body>
                <rsuite.Modal.Footer>
                    <rsuite.Button appearance="primary" color="green" onClick={UpdateIsActive}>
                        بلی
                    </rsuite.Button>
                    <rsuite.Button appearance="subtle" onClick={() => (setShowModal(false), setId(General.GuidEmpty(), setDiscountTitle(""), setIsActive(-1)))}>
                        خیر
                    </rsuite.Button>
                </rsuite.Modal.Footer>
            </rsuite.Modal>

        </Layout >


    )
}

export default DiscountIndex;